import { action } from 'typesafe-actions'
import { UserInfoActionTypes } from './types'
import { IUser } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(UserInfoActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IUser[]) => action(UserInfoActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(UserInfoActionTypes.LIST_ERROR, errors)
export const listClear = () => action(UserInfoActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(UserInfoActionTypes.SELECT, id)
export const selectedData = () => action(UserInfoActionTypes.SELECTED)
export const selectedClear = () => action(UserInfoActionTypes.CLEAR_SELECTED)
